import React, { Component } from "react"

class SectionHeader extends Component {
  static defaultProps = {
    headline: "headline",
    modifierClass: "",
    buttonText: "next",
    nextStepPath: "",
    showButton: true,
    topPadding: "deck--padding-top",
    headerStyle: null,
  }

  state = {}

  handleForwardClick = () => {
    this.props.history.push({
      pathname: this.props.nextStepPath.path,
      search: this.props.nextStepPath.search || this.props.location.search,
    })
  }

  render() {
    return (
      <section className={`deck deck--white ${this.props.topPadding}`}>
        <div className="w--wider">
          <header className={`section-header ${this.props.modifierClass}`} style={this.props.headerStyle}>
            <div className="section-header__inner">
              <h2>{this.props.headline}</h2>
              {this.props.showButton ? (
                <nav className="section-header__inner__nav">
                  <button className="button button--link has-icon rm-this-class rm-this-class-hide-default" onClick={this.handleForwardClick}>
                    <span className="icon">
                      <svg className="svg-icon svg-icon--arrowright">
                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-arrowright">
                          &nbsp;
                        </use>
                      </svg>
                    </span>
                    <span className="text">{this.props.buttonText}</span>
                  </button>
                </nav>
              ) : (
                ""
              )}
            </div>
          </header>
        </div>
      </section>

      // <section className="deck deck--white deck--extra-padding-top deck--padding-bottom">
      //   <div className="w--wider">
      //     <header className="section-header section-header--slim">
      //       <div className="section-header__inner">
      //         <h2>{this.props.title}</h2>
      //         <nav className="section-header__inner__nav section-header__inner__nav--back">
      //           <button
      //             onClick={this.handleBackClick}
      //             className="button button--link has-icon rm-this-class rm-this-class-hide-default">
      //             <span className="icon">
      //               <svg className="svg-icon svg-icon--arrowleft">
      //                 <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-arrowleft">&nbsp;</use>
      //               </svg>
      //             </span>
      //             <span className="text">{textKeys.back || "Tilbage til Parkering"}</span>
      //           </button>
      //         </nav>
      //       </div>
      //     </header>
      //   </div>
      // </section>
    )
  }
}

export default SectionHeader
